import React from 'react';
import './Carousel.css'; // Import the CSS file

const Carousel = () => {
    return (
        <div>
            <div id="carouselExampleIndicators" className="carousel slide carousel-custom" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src="./images/img7.jpg" className="d-block w-100" alt="First Slide" />
                    </div>
                    <div className="carousel-item">
                        <img src="./images/beauty1.jpg" className="d-block w-100" alt="Second Slide" />
                    </div>
                    <div className="carousel-item">
                        <img src="./images/quran.jpg" className="d-block w-100" alt="Third Slide" />
                    </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    );
}

export default Carousel;
